import { gql } from "@apollo/client";

const LINK_ADDITIONAL_USER = gql`
mutation LinkAdditionalUser($token: String, $userLoginId: ID) {
  linkAdditionalUser(token: $token, userLoginId: $userLoginId) {
    _id
    associationType
    createdAt
    expectedEmail
    expectedFirstName
    expectedLastName
    inviteConfirmationToken
    inviteExpirationDate
    inviteStatus
    relationship
    successorPriority
    updatedAt
    meta {
      testData
    }
  }
}
`;

const ACKNOWLEDGE_USER_PRODUCT = gql`
mutation AcknowledgeUserProduct($userProductId: String!) {
  acknowledgeUserProduct(userProductId: $userProductId) {
    _id
  }
}
`;

export { LINK_ADDITIONAL_USER, ACKNOWLEDGE_USER_PRODUCT }